import { useEffect, useState } from "react"
import { useForms } from "./useForm"

const useUrlReturn = (formKey) => {
  const [url, setUrl] = useState("")
  const { salesforce } = useForms()

  useEffect(() => {
    const getUrlRetour = async () => {
      try {
        const response = await salesforce.getUrlRetour(formKey)
        setUrl(response)
      } catch (error) {
        console.error("Error fetching URL:", error)
      }
    }

    if (formKey && salesforce) {
      getUrlRetour()
    }
  }, [formKey, salesforce])

  return { url }
}

export default useUrlReturn
